export const reportTypeMap = {
  '0': '帖子举报',
  '1': '帖子申诉',
  '2': '圈子投诉',
  '3': '圈主/管理员举报',
  '4': '用户举报',
  '5': '评论举报',
  '6': '回复评论举报',
  '7': '艺局举报'
}

export const rankTypeMap = {
  post: '内容排行',
  points: '积分排行榜',
  balance: '贝壳排行榜',
  gift: '送礼物排行榜',
  receiveGift: '收礼物排行榜',
  invitation: '邀请排行榜'
}

const HOME = { path: '/home', name: '首页' }

const group = (name) => ({ name })

const page = (path, name, parents = []) => [
  HOME,
  ...parents.map(group),
  { path, name }
]

export const routeBreadcrumbMap = {
  '/home': [HOME],

  '/userHome': page('/userHome', '用户管理', ['用户信息']),
  '/userDeactivation': page('/userDeactivation', '注销列表', ['用户信息']),
  '/messagePage': page('/messagePage', '消息列表', ['用户信息', '消息管理']),
  '/adminMsg': page('/adminMsg', '消息管理', ['用户信息', '消息管理']),
  '/systemMsg': page('/systemMsg', '站内提醒', ['用户信息', '消息管理']),
  '/user/virtualUser': page('/user/virtualUser', '虚拟用户', ['用户信息']),
  '/super/admin': page('/super/admin', '超管列表', ['用户信息']),
  '/banSpeak': page('/banSpeak', '禁言列表', ['用户信息', '封禁管理']),
  '/muteAppeal': page('/muteAppeal', '禁言申诉', ['用户信息', '封禁管理']),
  '/banAppeal': page('/banAppeal', '封禁申诉', ['用户信息', '封禁管理']),
  '/banList': page('/banList', '封禁列表', ['用户信息', '封禁管理']),
  '/userRulesTmpl': page('/userRulesTmpl', '认证模板', ['用户信息', '认证管理']),
  '/realNameTmpl': page('/realNameTmpl', '实名认证模板', ['用户信息', '认证管理']),
  '/authenticationCategory': page('/authenticationCategory', '认证分类', ['用户信息', '认证管理']),
  '/userRules': page('/userRules', '用户认证', ['用户信息', '认证管理']),
  '/userRulesAuth': page('/userRulesAuth', '实名列表', ['用户信息', '认证管理']),
  '/faceAuthAttempts': page('/faceAuthAttempts', '人脸认证记录', ['用户信息', '认证管理']),
  '/invitationPage': page('/invitationPage', '邀请列表', ['用户信息']),
  '/appOnlineStats': page('/appOnlineStats', '实时统计', ['用户信息']),

  '/square': page('/square', '广场列表', ['广场管理']),
  '/circle': page('/circle', '圈子列表', ['广场管理', '圈子管理']),
  '/newCircle': page('/newCircle', '新建圈子', ['广场管理', '圈子管理']),
  '/adminCircle': page('/adminCircle', '圈子职位管理', ['广场管理', '圈子管理']),
  '/examineCircle': page('/examineCircle', '圈子创建审批', ['广场管理', '圈子管理']),
  '/adminCheckcCricle': page('/adminCheckcCricle', '圈子设置', ['广场管理', '圈子管理']),
  '/subJect': page('/subJect', '话题管理', ['广场管理']),
  '/artsBureau': page('/artsBureau', '艺局系统', ['广场管理']),

  '/tabgrade': page('/tabgrade', '等级列表', ['娱乐系统']),
  '/decoration': page('/decoration', '积分商城', ['娱乐系统']),
  '/memberEdit': page('/memberEdit', '会员设置', ['娱乐系统']),
  '/giftManagement': page('/giftManagement', '礼物管理', ['娱乐系统']),

  '/anonymousList': page('/anonymousList', '小秘密列表', ['帖子管理', '小秘密管理']),
  '/anonyConfig': page('/anonyConfig', '小秘密配置', ['帖子管理', '小秘密管理']),
  '/anonyReply': page('/anonyReply', '小秘密回复', ['帖子管理', '小秘密管理']),
  '/content': page('/content', '帖子列表', ['帖子管理']),
  '/contentAppeal': page('/contentAppeal', '内容申诉', ['帖子管理']),
  '/topContetn': page('/topContetn', '热门内容', ['帖子管理']),
  '/contentIndtaID': page('/contentIndtaID', '帖子详情', ['帖子管理']),
  '/replyContent': page('/replyContent', '评论列表', ['帖子管理']),
  '/detailReplyContent': page('/detailReplyContent', '评论回复', ['帖子管理']),
  '/replyContent/replyDetail': page('/replyContent/replyDetail', '评论详情', ['帖子管理']),

  '/giftRecord': page('/giftRecord', '赠礼记录', ['钱包管理']),
  '/user/withdraw': page('/user/withdraw', '用户提现', ['钱包管理']),
  '/runWallet': page('/runWallet', '钱包充值设置', ['钱包管理']),
  '/pointsExchange': page('/pointsExchange', '积分兑换记录', ['钱包管理']),

  '/serveContent': page('/serveContent', '服务中心配置', ['用户服务']),
  '/adConfig': page('/adConfig', '广告设置', ['用户服务']),
  '/taskCenterPage': page('/taskCenterPage', '任务中心', ['用户服务']),
  '/taskLog': page('/taskLog', '任务进度与奖励记录', ['用户服务']),
  '/feedBack': page('/feedBack', '用户反馈', ['用户服务']),
  '/aboutUs': page('/aboutUs', '关于我们', ['用户服务']),
  '/agreementConfig': page('/agreementConfig', '协议配置', ['用户服务']),

  '/userShare': page('/userShare', '邀请奖励配置', ['小程序管理']),
  '/custRelay': page('/custRelay', '自定义转发配置', ['小程序管理']),
  '/kindReminder': page('/kindReminder', '修改昵称限制', ['小程序管理']),
  '/traffic': page('/traffic', '流量主', ['小程序管理']),
  '/miniAppFeatures': page('/miniAppFeatures', '功能开关', ['小程序管理']),

  '/mymine': page('/mymine', '个人资料')
}
